<template>
  <div class="page-wrapper">
    <search-group title="" @search="findData" @clear="clearValue" :span="24" :btnOffset="20" :btnSpan="6"
                  :multipleLines="false" :inline="true"
                  style="padding: 0"
    >
      <Row class="mb16" :gutter="16">
        <Col span="5">
          <Select v-model="searchData.companyType"  placeholder="组织机构">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in companyListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select v-model="searchData.position"  placeholder="职位">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in positionListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
        <Col span="5">
          <Select v-model="searchData.projectFid"  placeholder="项目">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in projectListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
<!--        <Col span="5">-->
<!--          <Select v-model="searchData.twoCategoryName" placeholder="资产二级分类">-->
<!--            <Option value=''>请选择</Option>-->
<!--            <Option v-for="(item,index) in twoCategoryListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
<!--          </Select>-->
<!--        </Col>-->
<!--        <Col span="5">-->
<!--          <Select v-model="searchData.clockType"  placeholder="打卡类型">-->
<!--            <Option value=''>请选择</Option>-->
<!--            <Option v-for="(item,index) in clockTypeListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>-->
<!--          </Select>-->
<!--        </Col>-->
        <Col span="5">
          <Select v-model="searchData.clockResult"  placeholder="打卡状态">
            <Option value=''>请选择</Option>
            <Option v-for="(item,index) in clockResultListData" :value="item.value" :key="'keyB'+index">{{item.text}}</Option>
          </Select>
        </Col>
<!--        <Col span="5">-->
<!--          <Input placeholder="用户姓名" v-model="searchData.userName"></Input>-->
<!--        </Col>-->
      </Row>
      <Row class="mb16" :gutter="16">
        <Col span="5">
          <Date-picker style="width: 200px" type="date" v-model="searchData.clockTime" :clearable="false" placeholder="打卡日期" format="yyyy-MM-dd"></Date-picker>
        </Col>
      </Row>

    </search-group>

<!--    <div>-->
    <Button type="primary" @click="exportClock" :loading="btnLoading" v-p="{api:'clockin/exportClockinList'}">导出打卡记录</Button>
    <Button type="primary" @click.stop="goDetail">查看打卡统计</Button>
<!--    </div>-->

    <table-list
      class="mt12"
      :columns="columns"
      :data="data"
      :current="current"
      :total="total"
      :loading="loading"
      @change-page="changPage"
    ></table-list>

  </div>
</template>

<script type="text/ecmascript-6">
  import SearchGroup from 'components/SearchGroup/index';
  import TableList from 'components/TableList/index';
  import {getAllProject} from "../../api/user";
  import {getClockinRecordlist, checkClockCount, exportClockinList} from "../../api/clockin";
  import {formatDateTime} from "utils/format";
  export default {
    condition:'advice',
    components: {
      SearchGroup,
      TableList
    },
    mounted() {
      this.searchData.projectFid=this.$route.query.projectFid||'';
      // console.log('xxxxxxxxxxxxxxxxxxxxxxxxx',this.$route.query.projectFid)
      this.findData()
    },
    computed: {
      searchDataComputed() {
        return {
          companyType: this.searchData.companyType,
          position:this.searchData.position,
          projectFid:this.searchData.projectFid,
          // userName: this.searchData.userName,
          clockTime:this.searchData.clockTime,
          // clockType:this.searchData.clockType,
          clockResult:this.searchData.clockResult
        }
      }
    },
    watch: {
    },
    activated(){
      this.searchData.projectFid=this.$route.query.projectFid;
      // console.log('xxxxxxxxxxxxxxxxxxxxxxxxx',this.$route.query.projectFid)
    },
    data() {
      return {
        btnLoading:false,
        searchParams:null,
        data: [],
        companyListData:[{
          value: 'e498159c2cee4e129d200fa7a39ba055',
          text: '北京分公司',
        },
          {
            value: '0b8d764f580642f3b4ec6fec6b8bfa66',
            text: '新疆分公司',
          }],
        positionListData:[{
          value: '1003',
          text: '管理人员',
        },
          {
            value: '1002',
            text: '普通员工',
          }],
        projectListData:[],
        clockTypeListData:[{
          value: 1,
          text: '上班打卡',
        },
          {
            value: 2,
            text: '下班打卡',
          }],
        clockResultListData:[{
          value: 1,
          text: '正常',
        },
          {
            value: 2,
            text: '迟到',
          },{
            value: 3,
            text: '早退',
          },
          {
            value: 4,
            text: '旷工',
          }],
        columns: [
          {
            type: 'index',
            width: 60,
            key:'fid',
            align: 'center',
          },
          {
            title: ' '
          },
          {
            title: '姓名 ',
            key: 'personName',
            width: 180,
          },

          {
            title: ' '
          },
          {
            title: "所属项目",
            key: 'projectName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: '打卡类型',
            key: 'clockTypeName',
            width: 130,

          },
          {
            title: ' '
          },
          {
            title: "打卡时间",
            key: 'clockTime',
            width: 180,
            render:(h,params)=>{
              return h('span',{},formatDateTime(params.row['clockTime'],true))
            }
          },
          {
            title: ' '
          },
            {
            title: "打卡结果",
            key: 'clockResultName',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: "打卡地点",
            key: 'clockPlace',
            width: 180,
          },
          {
            title: ' '
          },
          {
            title: '操作',
            align: 'center',
            width: 150,
            fixed: 'right',
            render:(h,params)=>{
              const clock = h('a', {
                on: {
                  click: () => {
                    this.$router.push({path:'/app/seeClockinRecord',query:{id:params.row.personCode}});
                  }
                }
              }, '查看打卡记录');
              return h('div',{},[clock])
            }
          },
        ],
        total: 0,
        current: 1,
        loading: false,
        metaList:[],
        page:1,
        limit:10,
        searchData: {
          companyType:'',
          projectFid: '',
          // userName: '',
          clockTime:new Date(),
          // clockType:'',
          clockResult:'',
          position:''
        },
      }
    },
    methods: {
      exportClock(){
        const data = {};
        for (const key in this.searchData) {
          if(key==='page' || key==='limit') continue;
          data[key] = this.searchData[key]
        }
        checkClockCount(data).then( res => {
          if(res.data > 10000){
            this.$Modal.info({
              title: '导出合同',
              content:'上限3000条，请选择条件后下载'
            });
          } else {
            this.btnLoading = true;
            exportClockinList(data).then( res => {
              console.log(res.headers,'headers.......')
              const fileName = res.headers.filename || 'excel.xls';
              const blob = new Blob([res.data]);
              const url = window.URL.createObjectURL(blob);
              const link = document.createElement('a');
              link.style.display = 'none';
              link.href = url;
              link.setAttribute('download', fileName);
              document.body.appendChild(link);
              link.click();
              this.btnLoading = false
            }).catch( err => {
              this.btnLoading = false;
              console.log('err')
            })
          }
        })

      },
      getData(){
        const params={
          ...this.searchParams,
          page:this.page,
          limit:this.limit
        }
          getClockinRecordlist(params).then(res=>{
          if(!res.data){
            return
          }
          this.total=res.data.total
          this.data=res.data.rows?res.data.rows:[]
        }).catch(error=>{
        })

      },
      changPage(n){
        this.current = n;
        this.page = n;
        this.getData()
      },
      findData() {
        this.searchParams=this.searchDataComputed
        this.page=1
        this.current=1
        this.getData()
      },
      clearValue() {
        this.searchData = {
          projectFid: '',
          userName: '',
          clockTime: '',
          clockType:'',
          clockResult:''
        }
      },
      changeTableRowTextExpandState(i){
        this.data = this.data.map(( item,index ) => {
          if( i === index ){
            item.expandText = !item.expandText
          }
          return item;
        })
      },
      goDetail() {
        console.log(this.searchData.clockTime)
        this.$router.push({ path: `/app/clockinstatics`, query: {time: formatDateTime(this.searchData.clockTime,false) } });
      }
    },
    created() {
      getAllProject(
          {}
      ).then(res => {
        if (!res.data) {
          return
        }
        this.projectListData = res.data;
      }).catch(() => {
        return
      })
    }
  }
</script>

<style scoped>
  .width3 {
    width: 200px;
  }
  .wrappertabs{
    min-height: 400px;
  }
</style>
<style>
  .feedback-text-wrapper{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  .feedback-text-container > .ivu-table-cell > div{
    padding: 10px 0;
    overflow: hidden;
  }
</style>